import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import MovieContext from './context/store';

const Mood = ({getdata}) => {

    const context = React.useContext(MovieContext);

    const handleChange = (event) => {
        context.handleMood(event.target.value);
        getdata();
    }

    return (
        <div>
            <h1>What Mood are you in?</h1>
            <FormControl>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="female"
        name="radio-buttons-group"
        onChange={(event) => handleChange(event)}
      >
        <FormControlLabel value="happy" control={<Radio />} label="Happy" />
        <FormControlLabel value="sad" control={<Radio />} label="Sad" />
        <FormControlLabel value="angry" control={<Radio />} label="Angry" />
        <FormControlLabel value="chill" control={<Radio />} label="Chill" />
        <FormControlLabel value="romantic" control={<Radio />} label="Romantic" />
        <FormControlLabel value="anxious" control={<Radio />} label="Anxious" />
        <FormControlLabel value="silly" control={<Radio />} label="Silly" />
        <FormControlLabel value="motivated" control={<Radio />} label="Motivated" />
        <FormControlLabel value="curious" control={<Radio />} label="Curious" />
      </RadioGroup>
    </FormControl>
        </div>
    )
}

export default Mood;